import type { McpApiKeyScope } from '@/hooks/use-mcp-keys'

export interface McpScopeMeta {
  value: McpApiKeyScope
  label: string
  description: string
  isWrite: boolean
}

export const MCP_SCOPES: McpScopeMeta[] = [
  {
    value: 'data:read',
    label: 'Read data',
    description: 'Read-only access to prompts, scores, sources, and reports.',
    isWrite: false,
  },
  {
    value: 'scans:run',
    label: 'Run scans',
    description: 'Lets a connected client run scans, which spends credits.',
    isWrite: true,
  },
  {
    value: 'reports:write',
    label: 'Generate reports',
    description: 'Lets a connected client generate and save reports.',
    isWrite: true,
  },
  {
    value: 'content:write',
    label: 'Write content',
    description: 'Lets a connected client create or edit content briefs.',
    isWrite: true,
  },
  {
    value: 'projects:write',
    label: 'Manage projects',
    description: 'Lets a connected client create or modify websites and projects.',
    isWrite: true,
  },
]

export const SCOPE_LABEL: Record<McpApiKeyScope, string> = Object.fromEntries(
  MCP_SCOPES.map((s) => [s.value, s.label])
) as Record<McpApiKeyScope, string>

export const EXPIRY_OPTIONS = [
  { value: '30', label: '30 days' },
  { value: '90', label: '90 days' },
  { value: '365', label: '1 year' },
  { value: 'never', label: 'Never' },
] as const
